import classes from './Lessons.module.css'
import { useEffect, useMemo, useState } from 'react'
import SingleLesson from './SingleLesson';
import { useDispatch, useSelector } from 'react-redux';
import HeaderActionBar from '../HeaderActionBar/HeaderActionBar';
import { FilterTypesEnum } from '../../../UI/Filter';
import LessonsBtnMenu from './LessonsBtnMenu';
import mainRouteIcon from '../../../../assests/dashboard/lessons/homePageIcon.png'
import enrichmentIcon from '../../../../assests/dashboard/lessons/enrichmentIcon.png'
import contestIcon from '../../../../assests/dashboard/lessons/contestIcon.svg'
import { useParams } from 'react-router-dom';

const Lessons = () => {

    const dispatch = useDispatch();
    const { applictionName } = useParams();
    const uiData = useSelector((state) => state.general.uiData);
    const { lessonByTopic, studyGroup } = useSelector(state => state.topics);
    const { direction, texts } = useSelector((state) => state.translate);
    const [filteredFlatTopic, setFilteredFlatTopic] = useState()
    const [FlatTopic, setFlatTopic] = useState()
    const [lessonesListType, setLessonesListType] = useState()
    const [currentLessonsType, setCurrentLessonsType] = useState(0)
    const [noLessonsMessage, setNoLessonsMessage] = useState(null)
    const btnList = useMemo(() => [{ text: texts.mainLessonsRoute, icon: mainRouteIcon }, { text: texts.enrichment, icon: enrichmentIcon }, { text: texts.contest, icon: contestIcon }], [])

    useEffect(() => {
        if (uiData[applictionName]) {
            setLessonesListType(uiData[applictionName].lessonesListType)
        }
    }, [uiData])

    useEffect(() => {
        if (lessonByTopic && lessonesListType) {
            if (lessonByTopic[lessonesListType[currentLessonsType]]) {
                let l = lessonByTopic[lessonesListType[currentLessonsType]].map(t => {
                    return {
                        name: t.tag.name, lessons: t.lessons ? t.lessons.map(l => { return { id: l.id, name: l.name, submissionStatus: l.finalAssessment?.submission?.submissionStatus, scoreAdditionalData: l.finalAssessment?.submission?.scoreAdditionalData, ideId: l.finalAssessment?.ideId, indexOnMap: l.indexOnMap, isLate: l.isLate, index: l.index, lessonType: l.lessonType, active: l.active, activeFromDate: l.activeFromDate, activeToDate: l.activeToDate, currentDate: l.currentDate, ClientDate: l.ClientDate } }) : null
                    }
                })
                setFlatTopic(l)
                setFilteredFlatTopic(l)
                if (l.filter(l1 => l1.lessons && l1.lessons.length > 0).length > 0)
                    setNoLessonsMessage(null)
                else setNoLessonsMessage(texts.noLessons)
            }
            else
                setNoLessonsMessage(texts.noLessons)
        }
    }, [lessonByTopic, currentLessonsType, lessonesListType])


    const getValuesList = (field) => {

        let newArray = []
        FlatTopic && FlatTopic.forEach(element => {
            element.lessons && element.lessons.map(l => {
                if (l[field] && !newArray.includes(l[field]))
                    newArray.push(l[field])
            })
            newArray = newArray.sort()
        })
        newArray = newArray.sort()
        return newArray;
    }
    const filter = (inputs) => {
        const list = FlatTopic.map(topic => {
            let filetrLessons = topic.lessons && topic.lessons.filter(lesson =>
                Object.keys(inputs).map(key => {
                    if (key === "free") {
                        if (!inputs[key] || (inputs[key] && ["name", "submissionStatus"].some(field => lesson[field] && lesson[field].includes && lesson[field].includes(inputs[key]))))
                            return true;
                        else
                            return false
                    }
                    else {
                        if (inputs[key].length == 0 || inputs[key].includes(lesson[key]))
                            return true;
                        else
                            return false;
                    }
                }).every(x => x === true)
            )
            return { ...topic, lessons: filetrLessons };
        })
        setFilteredFlatTopic(list)
    }



    return (
        <>
            {<HeaderActionBar filtercb={filter} filters={[{ text: "חיפוש חופשי", name: "free", type: FilterTypesEnum.free }, { text: "סביבת פיתוח", values: getValuesList("ideId"), name: "ideId", type: FilterTypesEnum.values }, { text: "סטאטוס", values: getValuesList("submissionStatus"), name: "submissionStatus", type: FilterTypesEnum.values }]}>
            </HeaderActionBar>}
            <div className={classes.Assessments}>
                <div className={classes.TitleWrapper}>
                    <h1 className={classes.Title}>{texts.MyLessons}</h1>
                    {studyGroup && studyGroup.courseName && studyGroup.name && <h2 className={classes.CourseNameMap}><span className={classes.MyLessonsText}>{studyGroup.courseName} | </span>{studyGroup.name}</h2>}
                </div>
                {studyGroup && <div className={classes.LessonsWithMenu}>
                    <div className={classes.BtnMenuWarrper}>
                        <LessonsBtnMenu btnList={btnList} currentBtn={currentLessonsType} changeBtn={(newCurrentBtn) => setCurrentLessonsType(newCurrentBtn)} />
                    </div>
                    <div className={`${classes[direction]} ${classes.LessonsContainer}`}>
                        {noLessonsMessage ? <p className={classes.NoLessonsText}>{noLessonsMessage}</p> :
                            filteredFlatTopic && filteredFlatTopic.map((a, i) =>
                                <div key={i} className={classes.Lessons}>
                                    {a.lessons?.length > 0 && <h5 className={classes.TocName}>{a.name}</h5>}
                                    <div className={classes.AssessmentsWarrper}>
                                        {a.lessons?.map((b, index) =>
                                            <SingleLesson key={index} dataLesson={b} studyGroupId={studyGroup.id} ></SingleLesson>
                                        )}
                                    </div>
                                </div>
                            )}
                    </div>
                </div>}
            </div>
        </>
    )
}
export default Lessons